import React from 'react';

import { Divider, Popover, Row, Typography } from 'antd';

import {
  GroupElementWrapper,
  HeaderGroupElement,
} from 'pages/product-full-view/shared/components';

import { ProductOverlayPrimitiveValue } from './ProductOverlayPrimitiveValue';

import {
  checkIsValidObjectValues,
  checkNestedPropertyHasValidValues,
} from '../utils';

import { checkDiffProductValueOverlay } from './utils';

export const ProductOverlayPropertyItem = ({
  property,
  dataProductOverlay = {},
  dataOriginalProduct = {},
  productEnums,
}) => {
  const { childProperties, propertyDisplayName, fieldFullPath } = property;

  const isNestedProperty = childProperties?.length > 0;

  if (isNestedProperty) {
    const valuesOverlay = dataProductOverlay?.[fieldFullPath] ?? [];
    const originalValues = dataOriginalProduct?.[fieldFullPath] ?? [];

    const isValidValues = checkNestedPropertyHasValidValues(valuesOverlay);

    return (
      <>
        {isValidValues && (
          <Row style={{ marginTop: 12, marginRight: 12 }}>
            <GroupElementWrapper
              span={24}
              style={{ padding: '8px 0px', marginTop: 8 }}
            >
              <HeaderGroupElement
                className='product-detail__group-header'
                header={propertyDisplayName}
              />
              {valuesOverlay.map((valueOverlay, index) => {
                const lastIndex = index === valuesOverlay.length - 1;
                const isValidObject = checkIsValidObjectValues(valueOverlay);
                const originalValue = originalValues?.[index] ?? {};

                return (
                  <React.Fragment key={index}>
                    <PropertyNestedOverlay
                      properties={childProperties}
                      dataOverlay={valueOverlay}
                      originalData={originalValue}
                      productEnums={productEnums}
                    />
                    {lastIndex || !isValidObject ? null : (
                      <Divider
                        style={{
                          margin: '12px 8px',
                          minWidth: '96%',
                          width: '96%',
                          borderTopColor: '#f0f0f0',
                        }}
                      />
                    )}
                  </React.Fragment>
                );
              })}
            </GroupElementWrapper>
          </Row>
        )}
      </>
    );
  }

  return (
    <ProductOverlayPrimitiveValue
      property={property}
      productEnums={productEnums}
      dataProductOverlay={dataProductOverlay}
      dataOriginalProduct={dataOriginalProduct}
    />
  );
};

export const PropertyNestedOverlay = ({
  properties,
  dataOverlay,
  originalData,
  productEnums,
}) => {
  const renderElement = ({
    childProperty,
    dataOverlay,
    originalData,
    productEnums,
  }) => {
    const { childProperties, propertyDisplayName, fieldFullPath } =
      childProperty;

    if (childProperties?.length > 0) {
      const valuesOverlay = dataOverlay?.[fieldFullPath] ?? [];
      const originalValues = originalData?.[fieldFullPath] ?? [];

      const isValidValues = checkNestedPropertyHasValidValues(valuesOverlay);

      return (
        <>
          {isValidValues && (
            <Row style={{ marginTop: 12, marginRight: 12 }}>
              <GroupElementWrapper
                span={24}
                style={{ padding: '6px 4px', marginTop: 12 }}
              >
                <HeaderGroupElement
                  className='product-detail__group-header'
                  header={propertyDisplayName}
                />
                {valuesOverlay.map((valueOverlay, index) => {
                  const lastIndex = index === valuesOverlay.length - 1;
                  const isValidObject = checkIsValidObjectValues(valueOverlay);

                  const originalValue = originalValues?.[index] ?? {};

                  return (
                    <React.Fragment key={index}>
                      <PropertyNestedOverlay
                        properties={childProperties}
                        dataOverlay={valueOverlay}
                        originalData={originalValue}
                        productEnums={productEnums}
                      />
                      {lastIndex || !isValidObject ? null : (
                        <Divider
                          style={{
                            margin: '12px 8px',
                            minWidth: '96%',
                            width: '96%',
                            borderTopColor: '#f0f0f0',
                          }}
                        />
                      )}
                    </React.Fragment>
                  );
                })}
              </GroupElementWrapper>
            </Row>
          )}
        </>
      );
    }

    return (
      <ProductOverlayPrimitiveValue
        property={childProperty}
        productEnums={productEnums}
        dataOriginalProduct={originalData}
        dataProductOverlay={dataOverlay}
      />
    );
  };

  return (
    <>
      {properties.map((childProperty) => {
        return (
          <div
            style={{ marginTop: 6, marginLeft: 12 }}
            key={childProperty.fieldFullPath}
          >
            {renderElement({
              childProperty,
              dataOverlay,
              originalData,
              productEnums,
            })}
          </div>
        );
      })}
    </>
  );
};

export const OverlayValueWrapper = ({
  originalValue,
  valueOverlay,
  contentOrigin,
  property,
  children,
  ...rest
}) => {
  const isDiffValue = checkDiffProductValueOverlay({
    property,
    originalValue,
    valueOverlay,
  });

  let element = children;

  if (isDiffValue) {
    element = (
      <Popover
        title={
          <Typography.Text strong>
            Original Value - {property?.propertyDisplayName}
          </Typography.Text>
        }
        trigger='hover'
        overlayInnerStyle={{ minWidth: 400, paddingBottom: 4 }}
        overlayClassName='product-detail-view__overlay'
        content={contentOrigin}
        {...rest}
      >
        <div className='product-detail-view__overlay-value'>{children}</div>
      </Popover>
    );
  }

  return element;
};
